import LocalityList from './LocalityList'
export {LocalityList}
export default LocalityList
